import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router } from '@angular/router';
import { JwtHelper } from 'angular2-jwt';
import { ConfigService } from '../../../../utils/config-service';

import { AccessToken } from '../../models';

declare const gapi: any;

@Injectable()
export class LoginDomainService {
  private oauth: any;
  private oauth$: BehaviorSubject<any>;
  private jwtHelper: JwtHelper;
  private accessToken: string;
  private googleClientId: string;
  private emailAddress: string;

  constructor(private zone: NgZone,
    private router: Router,
    private configService: ConfigService) {
    this.oauth$ = new BehaviorSubject<any>(undefined);
    this.jwtHelper = new JwtHelper();
    this.googleClientId = this.configService.getEnv('googleClientId');
  }

  getOauthInstance(): Observable<any> {
    if (!this.oauth) {
      this.loadOauth();
    }
    return this.oauth$;
  }

  loadOauth(): any {
    gapi.load('auth2', () => {
      this.zone.run(() => {
        this.oauth = gapi.auth2.init({
          client_id: this.googleClientId
        });
        this.oauth$.next(this.oauth);
      });
    });
  }

  getCurrentAccessToken(): any {
    let tokenString = localStorage.getItem('token');
    return JSON.parse(tokenString);
  }

  getDecodedAccessToken(): any {
    let token: any = this.getCurrentAccessToken();
    return this.jwtHelper.decodeToken(token.access_token);
  }

  isAuthenticated(): any {
    let token: any = this.getCurrentAccessToken();
    return this.jwtHelper.isTokenExpired(token.access_token);
  }

  getUserId(): string {
    let token: any = this.getCurrentAccessToken();
    let id = '';
    if (token && token.access_token) {
      let jwt = this.jwtHelper.decodeToken(token.access_token);
      id = jwt.sub;
    }
    return id;
  }

  checkImpersonation(): boolean {
    let token: any = this.getDecodedAccessToken();
    if (token.impersonated) {
      return true;
    } else {
      return false;
    }
  }

  setCurrentAccessToken(accessToken: any): void {
    localStorage.setItem('token', JSON.stringify(accessToken));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/login/login.domain.service.ts